import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  Signal,
  ViewChild,
  effect,
  inject,
} from '@angular/core';
import Chart, { ChartConfiguration, ChartConfigurationCustomTypesPerDataset } from 'chart.js/auto';
import 'chartjs-adapter-dayjs-4';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import { getMinMaxDate } from '../../services/assessmentsHistory.functions';
import {
  AssessmentChartDataRow,
  AssessmentChartDataSets,
  AssessmentType,
  Patient,
  SubTestChartDataSet,
  assessmentTypeColors,
} from '../../services/model';

import pattern from 'patternomaly';

@Component({
  selector: 'app-line-chart-nhpt-bars',
  standalone: true,
  imports: [],
  templateUrl: './line-chart-nhpt-bars.component.html',
  styleUrl: './line-chart-nhpt-bars.component.scss',
})
export class LineChartNhptBarsComponent implements OnInit {
  @Input() data!: Array<AssessmentChartDataRow> | undefined;
  @Input() dataFull!: Signal<AssessmentChartDataSets | undefined>;
  @Input() chartId!: string;
  @Input() patient!: Patient;
  @ViewChild('canvas', { read: ElementRef, static: true }) canvas!: ElementRef<any>;
  public chart: any;
  private cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  constructor() {
    dayjs.locale('de');
    // getPersistedConfig()

    effect(() => {
      this.dataFull();
      console.log('nhpt new dataFull signal event', this.dataFull());

      if (this.chart) {
        this.createChart();
        this.cdr.detectChanges();
        setTimeout(() => {
          // P.S. WTF!!!
          this.createChart();
          this.cdr.detectChanges();
        }, 50);
      }
    });
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.createChart();
      this.cdr.detectChanges();
    }, 50);
  }

  createChart() {
    // jür jedes Datum eine Row
    const datasetsObject: AssessmentChartDataSets = this.dataFull() ?? {};
    const { minDate, maxDate, labelDataFull } = getMinMaxDate(datasetsObject);

    // data Array enthält für jeden Behandlungstermin ein Element, also eine Row
    // da steht dann immer der im Drop-Down selektierte subType score drin, je links und rechts
    const dataRows: Array<AssessmentChartDataRow> = this.data ?? [];
    const assesmentType: AssessmentType = dataRows[0]?.type ?? 'ARAT';
    const color = assessmentTypeColors[assesmentType];
    const data = dataRows.map(row => {
      let score_left = 0;
      let score_right = 0;
      let sum_left = 0;
      let sum_right = 0;
      let overtime_left = 0;
      let overtime_right = 0;
      let unitLabel = '';
      if (this.chartId === 'nhpt') {
        unitLabel = 'Sekunden';
      }

      // zieh die daten von dem nhpt subTest
      const subTest: SubTestChartDataSet = row.subDataSets[0];
      score_left = subTest.score_left!;
      score_right = subTest.score_right!;
      sum_left = subTest.sumLeft!;
      sum_right = subTest.sumRight!;
      overtime_left = subTest.extraLeft!;
      overtime_right = subTest.extraRight!;

      // Invertierung Schädigung zu Erfüllung
      score_left = 100 - score_left;
      score_right = 100 - score_right;
      overtime_left = 100 - overtime_left;
      overtime_right = 100 - overtime_right;

      return {
        x: new Date(new Date(row.dateIso).toDateString()),
        dataL: score_left,
        dataR: score_right,
        overtimeL: score_left === 0 ? overtime_left : null,
        overtimeR: score_right === 0 ? overtime_right : null,
        ttovertimeL: score_left === 0 ? overtime_left + ' %' : null,
        ttovertimeR: score_right === 0 ? overtime_right + ' %' : null,
        tooltipLabelL: ` ${score_left} %  (${sum_left} ${unitLabel}) `,
        tooltipLabelR: ` ${score_right} %  (${sum_right} ${unitLabel}) `,
        documentId: row.documentId,
        assessmentType: row.type,
      };
    });

    // im multi-Line-chart haben wir immer nur 2 Datasets: eins für links und eins für rechts.
    // die liegen aber beide bereits in data. werden über den yAxisKey rausgefischt.
    const datasets = [
      {
        label: 'links' + (this.patient.affectedSide === 'l' || this.patient.affectedSide === 'b' ? ' (betroffen)' : ''),
        data: data,
        parsing: {
          yAxisKey: 'dataL',
        },
        borderWidth: 1,
        tension: 0.1,
        backgroundColor: color,
        borderColor: color,

        pointStyle: 'triangle',
        pointRadius: 5,
        pointHoverRadius: 10,
        borderDash: [3, 3],
      },
      {
        label:
          'rechts' + (this.patient.affectedSide === 'r' || this.patient.affectedSide === 'b' ? ' (betroffen)' : ''),
        data: data,
        parsing: {
          yAxisKey: 'dataR',
        },
        borderWidth: 1,
        tension: 0.1,
        backgroundColor: color,
        borderColor: color,

        pointStyle: 'rect',
        pointRadius: 5,
        pointHoverRadius: 10,
        borderDash: [12, 4],
      },
      {
        label: 'links' + (this.patient.affectedSide === 'l' || this.patient.affectedSide === 'b' ? ' (betroffen)' : ''),
        data: data,
        parsing: {
          yAxisKey: 'overtimeL',
        },
        type: 'bar',
        categoryPercentage: data.length < 4 ? 0.3 : 0.4,
        barPercentage: 1.0,
        backgroundColor: pattern.draw('triangle', color! + '90'),
        borderColor: color,
        minBarLength: 2,
      },
      {
        label:
          'rechts' + (this.patient.affectedSide === 'r' || this.patient.affectedSide === 'b' ? ' (betroffen)' : ''),
        data: data,
        parsing: {
          yAxisKey: 'overtimeR',
        },
        type: 'bar',
        categoryPercentage: data.length < 4 ? 0.3 : 0.4,
        barPercentage: 1.0,
        backgroundColor: pattern.draw('square', color! + '85'),
        borderColor: color,
        minBarLength: 2,
      },
    ];

    const config = this.getChartConfig(datasets, minDate, maxDate, labelDataFull);

    // P.S. WTF!!! WTFFF
    // für später: selbst geprüft: das chart verschwindet vom scrren nach dem destroy. Die Daten stimmen!
    // Und doch wird genau der alte chart wieder gezeichnet. Der cached das irgendwie. Erst nochmal konplett zeichnen hilft!

    if (this.chart) {
      this.chart.destroy();
    }
    // if (this.chart) {
    //   this.chart.data = { labels: labelDataFull, datasets: datasets };
    //   this.chart.options.scales.x.min = minDate;
    //   this.chart.options.scales.x.max = maxDate;
    //   this.chart.update();
    // } else {
    this.chart = new Chart(this.canvas.nativeElement, config);
    // }
  }

  getChartConfig(
    datasets: any,
    minDate: any,
    maxDate: any,
    labelDataFull: any
  ): ChartConfiguration | ChartConfigurationCustomTypesPerDataset {
    return {
      type: 'line',
      data: {
        labels: labelDataFull,
        datasets: datasets,
      },
      options: {
        responsive: true,
        aspectRatio: 3,
        animation: {
          delay: 100,
        },
        clip: false,
        layout: {
          // autoPadding: true,
          //   padding: {
          //     left: -10,
          //     right: 10,
          //   },
        },
        scales: {
          y: {
            min: 0,
            max: 100,
            reverse: false,
            position: 'right',
            beginAtZero: true,
            grid: {
              display: false,
            },
            ticks: {
              callback: function (val, index) {
                return val + ' %';
              },
            },
          },
          x: {
            offset: true,
            grid: {
              display: true,
            },
            type: 'time',
            min: minDate,
            max: maxDate,
            time: {
              unit: 'week',
              isoWeekday: true,
              displayFormats: {
                week: 'dd, DD.MM.YY',
              },
              tooltipFormat: 'dd, DD.MM.YYYY',
            },
          },
        },
        plugins: {
          title: {
            display: false,
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                const raw = context.raw as any;
                const yAxisKey = (context.dataset.parsing as any).yAxisKey;
                if (yAxisKey === 'dataL') {
                  return raw.tooltipLabelL;
                } else if (yAxisKey === 'dataR') {
                  return raw.tooltipLabelR;
                } else if (yAxisKey === 'overtimeL') {
                  return raw.ttovertimeL;
                } else if (yAxisKey === 'overtimeR') {
                  return raw.ttovertimeR;
                } else {
                  return raw.tooltipLabel;
                }
              },
            },
          },
          legend: {
            position: 'top',
            align: 'start',
            labels: {
              usePointStyle: true,
            },
          },
        },
      },
      plugins: [this.customCanvasBackgroundColor], // this.customLegend
    };
  }

  // nach Erfüllung (beste werte oben)
  drawChartBackgroundReverse(gradientBack: any) {
    gradientBack.addColorStop(0, 'rgba(251,221,221,1)');
    gradientBack.addColorStop(0.05, 'rgba(251,221,221,1)');

    gradientBack.addColorStop(0.05, 'rgba(255,228,200,1)');
    gradientBack.addColorStop(0.51, 'rgba(255,228,200,1)');

    gradientBack.addColorStop(0.51, 'rgba(252,244,219,1)');
    gradientBack.addColorStop(0.75, 'rgba(252,244,219,1)');

    gradientBack.addColorStop(0.75, 'rgba(252,252,239,1)');
    gradientBack.addColorStop(0.96, 'rgba(252,252,239,1)');

    gradientBack.addColorStop(0.96, 'rgba(255,255,255,1)');
    gradientBack.addColorStop(1, 'rgba(255,255,255,1)');
  }

  customCanvasBackgroundColor = {
    id: 'customCanvasBackgroundColor',
    beforeDraw: (chart: any, args: any, options: any) => {
      const {
        ctx,
        chartArea: { left, right, top, bottom, width, height },
      } = chart;
      const canvas = chart.canvas;
      const chartArea = chart.chartArea;

      ctx.save();
      // Chart background
      const gradientBack = canvas.getContext('2d').createLinearGradient(right, bottom, right, top);
      this.drawChartBackgroundReverse(gradientBack);
      ctx.fillStyle = gradientBack;
      ctx.fillRect(
        chartArea.left,
        chartArea.bottom,
        chartArea.right - chartArea.left,
        chartArea.top - chartArea.bottom
      );
    },
  };
}
